// 标准产品编码
import moment from "moment";

export const projectCode = {
  // topProjectAutumnOnlineCode: 'CO2024108', // 秋季开课：寒假在线 测试环境

  CO2024010: "CO2024010", // 秋季开课：暑期在线
  CO2024041: "PL00018", // 寒假开课：暑期在线（精英班） | 寒假开课：暑期在线 | 包含春季专题研究时间课程 |

  CO2024004: "PL00001", // 秋季专题研究时间课程 拔尖
  topProjectAutumnOnlineCode: "PL00001", // 秋季开课：寒假在线 CO2024004
  CO2024034: "PL00002,PL00017", // 三月开课：暑期在线 CO2024034
  CO2024047: "PL00003,PL00016", // 三月开课：暑期在线 CO2024047
  CO2024008: "PL00004", // 寒假开课：暑期在线（精英班） | 寒假开课：暑期在线 | 包含春季专题研究时间课程 | PL00004
  CO2024035: "PL00005", // 三月开课：暑期实地 CO2024035
  CO2024048: "PL00006", // 三月开课：暑期在线 CO2024048
  CO2024024: "PL00007", // 寒假开课：暑期实地（精英班）
  summerProjectCode: "PL00008", //秋季开课：暑期实地 CO2024023
  CO2024039: "PL00009", // 三月开课：暑期实地 CO2024039
  CO2024032: "PL00010", // 春季专题研究时间课程 | 寒假开课：暑期在线 拔尖 CO2024032
  CO2024040: "PL00011", // 春季专题研究时间课程 | 寒假开课：暑期在线 拔尖 CO2024040
  oneVipProjectCode: "PL00012", // 1v1项目
  PL00013: "PL00013", // 拔尖计划
  PL00014: "PL00014", // 拔尖计划
  CO2024078: "PL00007,PL00008", // 三月开课：暑期在线 CO2024034
  // CO20250604: "PL00022", // 春季专题研究时间课程 | 寒假开课：暑期在线 拔尖 CO2024032
  CO20250604: "PL00025", // 春季专题研究时间课程 | 寒假开课：暑期在线 拔尖 CO2024032
  CO2025070710: "PL00029", //10月份
  CO2025070701: "PL00030", //1月份
  // v4.25.3 新增
  CO2025080609: "PL00038", // 9月开课
  CO2025080610: "PL00039", // 10月开课
  CO2025080610C: "PL00040", // 10月开课（常规班）
  CO2025080611: "PL00041", // 11月开课
  CO2025080601: "PL00042", // 1月开课

  // 8.27 新增
  CO2025082701: "PL00043", // 1月常规班（预修）
  CO2025082702: "PL00044", // 3月常规班

  topProjectOnlineCode: "P0121", // 拔尖线上项目
  // topProjectAutumnOnlineCode: 'CO2024108', // 拔尖线上秋季项目
  // topProjectSpringCode: 'P0136', // 拔尖春季项目
  // summerProjectCode: 'P0137', // 暑期项目
  cisProjectCode: "P0132,P0137",
  topLectureProjectCode: "P0131,P0136", // lecture拔尖项目
  // lectureProjectCode: 'P0131', // 纯lecture项目
  allLectureProjectCode: "P0131,P0132",
  allSpringProjectCode: "P0132,P0136",
  allResearchAndLectureProjectCode: "P0131,P0132,P0136,P0137",
  topProjectAllOnlineCode: "P0121,P0132", // 全部线上拔尖项目
  topProjectOfflineCode: "P0122", // 拔尖实地项目
  topProjectCode: "P0121,P0122", // 拔尖春季项目
  topProjectAllCode: "P0121,P0122", // 拔尖项目

  vipProjectCode: "P0125,P0127", // vip项目
  overseasProjectCode: "P0124", // 海外实地英美科研
  singaporeProjectCode: "P0130", // 海外实地新加坡
  overseasProjectAllCode: "P0124,P0130", // 全部海外实地项目
  overseasAndOneProjectCode: "P0124,P0130,P0125", // 海外和1v1编码
  allProjectCode: "P0131,P0132,P0136,P0137", // 全部项目编码
};
// #名额海报时间抓取
//
// #CIS
// 在线项目：research开始时间~ research 结束时间
// 实地项目：research开始时间~ research 结束时间
//
// #AIS
// 在线项目：research开始时间~ research 结束时间
// 实地项目：lecture 开始时间~ research 结束时间
/*
 *type === 'fall' 秋季开课  | 'spring' 春季开课  | 'winter' 寒假开课 | 'oneVone' 1v1
 * projectBgImage 名额海报项目背景
 * billClassifyDate 名额海报开课时间
 * projectTipsImage 名额海报 - 中间tips
 * projectTitleImage 名额海报 - 头部图
 * dateList  学期对应列表 - 日期
 * detailsOptions  学期对应 - 详情配置
 * detailsOptions -> courseArrangement Schedule
 */
export const homeListType = [
  {
    name: "Direct Research Track-Start on January",
    code: projectCode.topProjectAutumnOnlineCode,
    courseCategory: "1",
    type: "fall",
    dateList: [
      // {dateName: '直播课程开放截止时间:', dateValue: '2024.11.18', dateKey: ''},
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024004.png"),
    billClassifyDate: "2025年1月 - 2025年3月",
    detailsOptions: {
      // Teaching Platform
      teachingPlatform: {
        title: "Teaching Platform",
        content: "NeoSchool",
      },
      // 课程安排
      courseArrangement: {
        firstCourse: {
          title: "科研时间",
          content: "暑期在线课程安排",
        },
        secondCourse: {
          title: "实地时间",
          content: "暑期Professor-led Research",
        },
      },
    },
  },
  {
    name: "Regular Track(Pre)-Start on January",
    code: projectCode.CO2024034,
    courseCategory: "1",
    type: "fall",
    dateList: [
      {
        dateName: "专题研究实践课程:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024034.png"),
    billClassifyDate: "2025年1月-10月",
  },
  {
    name: "Regular Track-Start on March",
    code: projectCode.CO2024047,
    courseCategory: "1",
    type: "fall",
    dateList: [
      {
        dateName: "专题研究实践课程:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024047.png"),
    billClassifyDate: "2025年3月-10月",
  },
  {
    name: "【在线】6月开课（直研班）",
    code: projectCode.CO2024008,
    courseCategory: "1",
    type: "winter",
    dateList: [
      // {dateName: '专题研究实践课程：', dateValue: '2025.01.25', dateKey: ''},
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024008.png"),
    billClassifyDate: "2025年6月-2025年8月",
  },
  {
    name: "【在线】10月开课（常规班）",
    code: projectCode.CO2025070710,
    courseCategory: "1",
    type: "winter",
    dateList: [
      {
        dateName: "Professor-led Lecture:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/cis/topProject/CO2025082702.png"),
    billClassifyDate: "2025.10-2026.3",
  },
  {
    name: "Regular Track(Pre)-Start on January",
    code: projectCode.CO2025082701,
    courseCategory: "1",
    type: "winter",
    dateList: [
      {
        dateName: "Professor-led Lecture:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/cis/topProject/CO2025082701.png"),
    billClassifyDate: "2026.1-2026.8",
  },
  {
    name: "Regular Track-Start on March",
    code: projectCode.CO2025082702,
    courseCategory: "1",
    type: "winter",
    dateList: [
      {
        dateName: "Professor-led Lecture:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/cis/topProject/CO2025082702.png"),
    billClassifyDate: "2026.3-2026.8",
  },
  {
    name: "【在线】1月开课（直研班）",
    code: projectCode.CO2025070701,
    courseCategory: "1",
    type: "winter",
    dateList: [
      // {dateName: '专题研究实践课程：', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/cis/topProject/CO2025070701.png"),
    billClassifyDate: "2026.1-2026.3",
  },
  {
    name: "【在线】8月开课（直研班）",
    code: projectCode.CO2024041,
    courseCategory: "1",
    type: "winter",
    dateList: [
      // {dateName: '专题研究实践课程：', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024041.png"),
    billClassifyDate: "2025年8月-10月",
  },
  {
    name: "Regular Track(Pre)-Start on January",
    code: projectCode.CO2024035,
    courseCategory: "1",
    type: "winter",
    dateList: [
      {
        dateName: "专题研究实践课程:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024035.png"),
    billClassifyDate: "2025年1月-2025年7月（A期）/8月（B期）",
  },
  {
    name: "Regular Track-Start on March",
    code: projectCode.CO2024048,
    courseCategory: "1",
    type: "winter",
    dateList: [
      {
        dateName: "专题研究实践课程:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024048.png"),
    billClassifyDate: "2025年3月-2025年7月（A期）/8月（B期）",
  },
  {
    name: "7月开课：暑期科研（直研班)",
    code: projectCode.CO2024078,
    courseCategory: "1",
    type: "fall",
    dateList: [
      // {dateName: '直播课程开放截止时间：', dateValue: '2024.11.18', dateKey: ''},
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/PL00007.png"),
    billClassifyDate: "2025年7月（A期）/8月（B期）",
  },
  {
    name: "【混合】7月开课（直研班）",
    code: projectCode.CO2024039,
    courseCategory: "1",
    type: "fall",
    dateList: [
      // {dateName: '直播课程开放截止时间：', dateValue: '2024.11.18', dateKey: ''},
      {
        dateName: "专题研究实践课程:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024039.png"),
    billClassifyDate: "2025年7月-2025年9月",
  },
  {
    name: "AIS列表页",
    code: projectCode.CO2024032,
    courseCategory: "0",
    type: "fall",
    dateList: [
      // {dateName: '专题课程:', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "Research Paper Mentorship:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00010.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/CO2024032_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/CO2024032_tips.png"),
    billClassifyDate: "2025年5月-2025年6月",
  },
  {
    note: "注释:AIS-9月开课",
    name: "AIS列表页",
    code: projectCode.CO2025080609,
    courseCategory: "0",
    type: "fall",
    dateList: [
      // {dateName: '专题课程:', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "Research Paper Mentorship:",
        dateValue: "",
        dateKey: "researchCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00033.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    billClassifyDate: "2025年9月-2025年11月",
  },
  {
    note: "注释:AIS-10月开课",
    name: "AIS列表页",
    code: projectCode.CO2025080610,
    courseCategory: "0",
    type: "fall",
    dateList: [
      // {dateName: '专题课程:', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "Research Paper Mentorship:",
        dateValue: "",
        dateKey: "researchCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00033.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    billClassifyDate: "2025.10-2025.12",
  },
  {
    note: "注释:AIS-10月开课常规班",
    name: "AIS列表页",
    code: projectCode.CO2025080610C,
    courseCategory: "0",
    type: "fall",
    dateList: [
      {
        dateName: "Core Hours of Learning:",
        dateValue: "",
        dateKey: "lectureCourseBeginTime",
      },
      {
        dateName: "Research Paper Mentorship:",
        dateValue: "",
        dateKey: "researchCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00033.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    billClassifyDate: "2025.10-2026.3",
  },
  {
    note: "注释:AIS-11月开课",
    name: "AIS列表页",
    code: projectCode.CO2025080611,
    courseCategory: "0",
    type: "fall",
    dateList: [
      // {dateName: '专题课程:', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "Research Paper Mentorship:",
        dateValue: "",
        dateKey: "researchCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00033.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    billClassifyDate: "2025.11-2026.1",
  },
  {
    note: "注释:AIS-1月开课",
    name: "AIS列表页",
    code: projectCode.CO2025080601,
    courseCategory: "0",
    type: "fall",
    dateList: [
      // {dateName: '专题课程:', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "Research Paper Mentorship:",
        dateValue: "",
        dateKey: "researchCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00033.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/PL00033_tips.png"),
    billClassifyDate: "2026.1-2026.3",
  },
  {
    name: "AIS列表页",
    code: projectCode.CO20250604,
    courseCategory: "0",
    type: "fall",
    dateList: [
      // {dateName: '专题课程:', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "Research Paper Mentorship:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00010.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/CO2024032_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/CO2024032_tips.png"),
    billClassifyDate: "2025年8月-2025年9月",
  },
  {
    name: "AIS列表页",
    code: projectCode.CO2024040,
    courseCategory: "0",
    type: "fall",
    dateList: [
      { dateName: "专题课程:", dateValue: "", dateKey: "firstCourseBeginTime" },
      {
        dateName: "Research Paper Mentorship:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00011.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/CO2024032_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/CO2024032_tips.png"),
    billClassifyDate: "2025年7月-2025年8月",
  },
  {
    name: "1-on-1 Customized Mentorship Program",
    code: "1v1",
    type: "oneVone",
    dateList: [],
  },
  {
    name: "拔尖计划-online-3月开课(PL00013)",
    code: projectCode.PL00013,
    courseCategory: "0",
    type: "fall",
    dateList: [
      {
        dateName: "专题研究实践课程:",
        dateValue: "",
        dateKey: "firstCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/topProject/CO2024004.png"),
    billClassifyDate: "2025年1月 - 2025年3月",
    detailsOptions: {
      // 课程安排
      courseArrangement: {
        firstCourse: {
          title: "科研时间",
          content: "暑期在线课程安排",
        },
        secondCourse: {
          title: "实地时间",
          content: "暑期Professor-led Research",
        },
      },
    },
  },
  {
    name: "AIS-online-交大-3月开课(PL00014)",
    code: projectCode.PL00014,
    courseCategory: "0",
    type: "fall",
    dateList: [
      // {dateName: '专题课程:', dateValue: '', dateKey: 'firstCourseBeginTime'},
      {
        dateName: "论文写作:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ],
    projectBgImage: require("@/assets/img/billClassify/ais/PL00010.png"),
    projectTipsImage: require("@/assets/img/billClassify/ais/CO2024032_tips.png"),
    projectTitleImage: require("@/assets/img/billClassify/ais/CO2024032_tips.png"),
    billClassifyDate: "2025年3月-2025年6月",
    detailsOptions: {
      // 课程安排
      courseTime: {
        firstCourseTime: {
          name: "Professor-led Lecture",
        },
        secondCourseTime: {
          name: "论文写作与评审",
        },
      },
    },
  },
];

// 获取日期数组
export const getDateList = (item) => {
  const { coursePackageCode, productPackageCode, courseCategory } = item;
  const list = homeListType.find(
    (v) =>
      v.code.includes(coursePackageCode || productPackageCode) &&
      courseCategory == v.courseCategory
  );
  return (
    (list && list.dateList) || [
      {
        dateName: "Professor-led Research:",
        dateValue: "",
        dateKey: "secondCourseBeginTime",
      },
    ]
  );
};

// 根据当前日期返回减14的日期
export const getReachDate = (date) => {
  // 兼容ios日期转换
  date = date.replace(/-/g, "/");
  return moment(date).subtract(14, "days").format("YYYY.MM.DD");
};

// CIS卓越学者计划
export const cisProjectCodeType = [
  projectCode.topProjectAutumnOnlineCode,
  projectCode.summerProjectCode,
  projectCode.CO2024008,
  projectCode.CO2024024,
];

// 拔尖计划类型
export const bajianCodeType = [projectCode.CO2024004, projectCode.CO2024008];

// 秋季code
export const isFallCodeFun = (item) => {
  const fallCode = [
    projectCode.topProjectAutumnOnlineCode,
    projectCode.summerProjectCode,
    projectCode.CO2024008,
  ];
  return fallCode.includes(item);
};
// CO2024010: 'CO2024010', // 秋季开课：暑期在线
// CO2024008: 'CO2024008', // 寒假开课：暑期在线（精英班） | 寒假开课：暑期在线 | 包含春季专题研究时间课程 |
// CO2024034: 'CO2024034', // 三月开课：暑期在线

// 海报跳转地址
export const haibaoPath = {
  [projectCode.topProjectAutumnOnlineCode]: "/BillClassify",
  [projectCode.CO2024032]: "/aisBillClassify",
  [projectCode.CO2024040]: "/aisBillClassify",
  [projectCode.CO20250604]: "/aisBillClassify",
  [projectCode.oneVipProjectCode]: "/BillClassify3",
  // v4.25.3 新增
  [projectCode.CO2025080609]: "/aisBillClassify2",
  [projectCode.CO2025080610]: "/aisBillClassify2",
  [projectCode.CO2025080610C]: "/aisBillClassify2",
  [projectCode.CO2025080611]: "/aisBillClassify2",
  [projectCode.CO2025080601]: "/aisBillClassify2",
};

export const coursePhasesAnyTimeFun = (item = {}) => {
  // console.log(item, "coursePhasesAnyTimeFun");
  const getDateList = (item = {}) =>
    homeListType.find(
      (v) =>
        v.code.includes(item.std) && item.courseCategory == v.courseCategory
    );
  // console.log(getDateList(item), 'getDateList')
  return getDateList(item) || {};
};

// 海报项目收获地址
export const projectPath = {
  // <!--秋季专题研究实践-->
  [projectCode.topProjectCode]: require("@/assets/img/billClassify/topProject/autumn_academic_harvest.png"),
  // <!--春季专题研究实践-->
  [projectCode.CO2024008]: require("@/assets/img/billClassify/topProject/spring_academic_harvest.png"),
  // <!--秋季在线科研-->
  [projectCode.topProjectAutumnOnlineCode]: require("@/assets/img/billClassify/topProject/autumn_center_harvest.png"),
  // <!--寒假暑期在线-->
  [projectCode.CO2024008]: require("@/assets/img/billClassify/topProject/spring_center_harvest.png"),
  // <!--秋季暑期实地-->
  [projectCode.summerProjectCode]: require("@/assets/img/billClassify/topProject/autum_center_summer_harvest.png"),
  // <!--寒假暑期实地-->
  [projectCode.CO2024024]: require("@/assets/img/billClassify/topProject/spring_center_summer_harvest.png"),
};

// 海外校区值
export const overseasSchoolCity = {
  westSchoolCity: "19,20", // 英美校区
  columbiaSchool: "19", // 哥伦比亚大学校区
  oxfordSchool: "20", // 牛津大学校区
  singaporeSchoolCity: "23", // 新加坡校区
  allSchoolCity: "19,20,23",
};

// 招生状态
export const QuotaStatus = {
  1: "招生",
  2: "紧张",
  3: "满额",
  4: "停招",
};

// 名额海报招生状态
export const posterStatus = {
  1: "Open",
  2: "Limited",
  3: "Full",
  4: "Closed",
};

export const courseType = {
  1: "NeoSchool平台直播",
  2: "NeoSchool平台直播 + 线下实地授课",
  3: "NeoSchool平台直播 + 线下实地授课",
};

// 校区地址
export const courseCity = {
  11: "中国科学院大学雁栖湖校区",
  12: "上海交通大学七宝校区",
  13: "广州校区", // 广州 · 大学城校区
  14: "杭州 · 西湖校区",
  15: "成都 · 华西校区",
  16: "武汉 · 东湖校区",
  17: "南京 · 四牌楼校区",
  18: "西安 · 雁塔校区",
  19: "美国 · 哥伦比亚大学校区",
  20: "英国 · 牛津大学校区",
  21: "英国 · 剑桥大学校区",
  22: "华南理工大学国际校区", // 广州
  23: "新加坡 · 新加坡国立大学",
};

//课题难度
export const courseDifficulty = {
  1: "General",
  2: "In-depth",
};
